import React from "react";
import { ModalType, useModal } from "../../../../Context/ModalContext";

function FontSelector(  ) {
  const { toggleShow } = useModal();

  return (
    <div className="toolbar-button"
         onClick={ () => {toggleShow( true, null, ModalType.font );} }
         data-test={"text-font"}>
      <i className="fas fa-font"></i>
    </div>
  );
}

export default FontSelector;